function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M4.4,9l-1-2H1v2h1.2c0,0,1.9,4.1,2.1,4.4c-1.1,0.6-1.8,1.8-1.8,3.1C2.5,18.4,4.1,20,6,20c1.8,0,3.2-1.3,3.5-3 h2.1c0.2,1.7,1.7,3,3.5,3c1.9,0,3.5-1.6,3.5-3.5c0-0.7-0.4-1.6-1.2-2.6c1.1-2,1.7-3.7,1.7-4.9H4.4z M6,18c-0.8,0-1.5-0.7-1.5-1.5 C4.5,15.7,5.2,15,6,15s1.5,0.7,1.5,1.5C7.5,17.3,6.8,18,6,18z M15,18c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5 C16.5,17.3,15.8,18,15,18z M16.7,11c-0.2,0.6-0.5,1.1-0.9,1.7L15.4,13c-0.1,0-0.3,0-0.4,0c-1.4,0-2.6,0.8-3.2,2H9.2 c-0.5-1-1.5-1.8-2.7-2L6,12.4c-0.1-0.2-0.3-0.7-0.7-1.4H16.7z M12,0v4h3l-4,4L7,4h3V0H12z"
});

var SvgInProgress = function SvgInProgress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInProgress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/in_progress.8ab8a118.svg";
export { ForwardRef as ReactComponent };